import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { openManagedMatDialog } from '@go-modules/utilities';
import { UniqueIdGeneratorUtil } from '@go-modules/utilities/unique-id-generator/unique-id-generator.util';
import { UADetect as UADetectClass, uaDetectToken } from 'go-modules/detect/ua-detect.service';
import { ActiveBrandService } from '@go-modules/services/active-brand';

export interface DownloadPWADialogData {
	dialogTitleId?: string;
}

@Component({
	selector: 'download-pwa-dialog',
	templateUrl: './download-pwa-dialog.component.html',
	styleUrls: ['./download-pwa-dialog.component.scss'],
	standalone: false
})
export class DownloadPWADialogComponent {

	public static open (
		dialog: MatDialog,
		config?: MatDialogConfig<DownloadPWADialogData>
	): MatDialogRef<DownloadPWADialogComponent, void> {
		const dialogTitleId = config?.data?.dialogTitleId ?? DownloadPWADialogComponent.getDialogTitleId();

		return openManagedMatDialog(dialog, DownloadPWADialogComponent, {
			...(config ?? {}),
			data: {
				...(config?.data ?? {}),
				dialogTitleId
			},
			ariaLabelledBy: dialogTitleId
		});
	}

	private static getDialogTitleId (): string {
		return `download-pwa-dialog-title-${UniqueIdGeneratorUtil.getId()}`;
	}

	constructor (
		private dialogRef: MatDialogRef<DownloadPWADialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: DownloadPWADialogData,
		@Inject(uaDetectToken) public UADetect: UADetectClass,
		private activeBrandService: ActiveBrandService
	) {
		this.data.dialogTitleId ??= DownloadPWADialogComponent.getDialogTitleId();
	}

	public get translationParams () {
		return this.activeBrandService.getTranslationParams();
	}

	public close () {
		this.dialogRef.close();
	}
}
